export default __webpack_public_path__ + "static/media/640_business02-es-web.0f77e785.png";